import { render } from "./pie-chart.vue?vue&type=template&id=2e98ce66&scoped=true"
import script from "./pie-chart.vue?vue&type=script&lang=js"
export * from "./pie-chart.vue?vue&type=script&lang=js"

import "./pie-chart.vue?vue&type=style&index=0&id=2e98ce66&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e98ce66"]])

export default __exports__